<template>
  <section class="box-layout" style="position: relative">
    <div class="manage-plan__content">
      <header class="content__header">
        <h2>{{ $t('userInfo.lnb.managePlan') }}</h2>
        <div class="button--wrap"></div>
      </header>
      <template v-if="isLoading">
        <ui-loading-circle :class="{ie: browser.isIE}"></ui-loading-circle>
      </template>
      <template v-else>
        <div class="content__body" ref="scrollContent">
          <div class="content__top">
            <content-box class="content__plan-in-use" :width="'65%'" :height="'240px'">
              <p class="content__title">
                {{ $t('common.planInUse') }}
                <span v-if="planData.useCoupon" class="coupon-text">{{ $t('common.coupon') }}</span>
              </p>
              <div class="content__plan-name">
                <strong class="plan-name" :class="{ using: planData.hasPlan }">
                  <template v-if="planData.hasPlan">
                    {{ planData.planName }}
                  </template>
                  <template v-else>{{ $t('common.noPlanInUse') }}</template>
                </strong>
              </div>
              <div class="content_outer">
                <div class="content">
                  <div class="plan-period">
                    <p class="label">{{ $t('common.subscriptionTerms') }}</p>
                    <p v-if="planData.hasPlan" class="value">
                      <time datetime="">{{ planData.startDate | dateFormatTimezone(userData.timezoneName) }}</time> ~
                      <time datetime="">{{ planData.endDate | dateFormatTimezone(userData.timezoneName) }}</time>
                    </p>
                    <p v-else class="value">-</p>
                  </div>
                  <div class="subscribe--wrap">
                    <template v-if="!planData.hasPlan">
                      <template v-if="planData.next">
                        <template v-if="planData.next.isCardPlan || planData.next.isWireTransferPlan">
                          <template v-if="planData.next.isCardPlan">
                            <p class="label">{{ planData.next.planName }}{{ $t('common.cardPlan') }}</p>
                          </template>
                          <template v-else>
                            <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                          </template>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                              nextStartDate: getLocaleDateStr(planData.next.startDate)
                            }) }}
                          </p>
                        </template>
                      </template>
                      <template v-else>
                        <div class="start-subscribe">
                          <p class="label">{{ $t('userInfo.managePlan.default.subscribe.toStart') }}</p>
                          <button @click="onChangePlan">
                            {{ $t('common.subscribeYourPlan') }}
                            <i class="icon icon--next-red-size16"></i>
                          </button>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="planData.isTrial">
                      <div class="start-subscribe">
                        <p class="label">{{ $t('userInfo.managePlan.default.subscribe.toContinue') }}</p>
                        <button @click="onChangePlan">
                          {{ $t('common.subscribeYourPlan') }}
                          <i class="icon icon--next-red-size16"></i>
                        </button>
                      </div>
                    </template>
                    <template v-else-if="planData.isUnpaid">
                      <ui-button :primary="true" :size="'large'" @click="isShowCancelSubscription = true">
                        {{ $t('common.cancelSubscription') }}
                      </ui-button>
                    </template>
                    <template v-else-if="planData.useCoupon || planData.isWireTransferPlan">
                      <template v-if="planData.next">
                        <template v-if="planData.next.isCardPlan || planData.next.isWireTransferPlan">
                          <template v-if="planData.next.isCardPlan">
                            <template v-if="planData.next.isSameAsCurrent || planData.next.isDowngrade">
                              <div class="start-subscribe">
                                <p class="label">
                                  {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                  nextPlan: planData.next.planName,
                                  nextStartDate: getLocaleDateStr(planData.next.startDate)
                                  }) }}
                                  <br>
                                  <button @click="onCancelSubscription(true)">
                                    {{ $t('common.cancelSubscription') }}
                                    <i class="icon icon--next-red-size16"></i>
                                  </button>
                                </p>
                              </div>
                            </template>
                            <template v-else>
                              <div class="start-subscribe">
                                <p class="label">
                                  {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                    nextPlan: planData.next.planName,
                                    nextStartDate: getLocaleDateStr(planData.next.startDate)
                                  }) }}
                                  <br>
                                  <button @click="onWithdrawPlanCancellation(true)">
                                    {{ $t('common.cancelPlanChange') }}
                                    <i class="icon icon--next-red-size16"></i>
                                  </button>
                                </p>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                            <p class="value">
                              {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                                nextStartDate: getLocaleDateStr(planData.next.startDate)
                              }) }}
                            </p>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <p class="label">{{ $t('userInfo.managePlan.default.subscribe.label.nextPlanExpire') }}</p>
                        <p class="value">
                          {{ computedPlanEndDate | localeDate }}
                        </p>
                      </template>
                    </template>
                    <template v-else-if="planData.isCardPlan">
                      <template v-if="planData.next">
                        <template v-if="planData.next.isCardPlan">
                          <template v-if="planData.next.isDowngrade">
                            <div class="start-subscribe">
                              <p class="label">
                                {{ $t('userInfo.managePlan.default.subscribe.downgrade', {
                                  nextPlan: planData.next.planName,
                                  nextStartDate: getLocaleDateStr(planData.next.startDate)
                                }) }}
                                <br>
                                <button @click="onWithdrawPlanCancellation(true)">
                                  {{ $t('common.cancelPlanChange') }}
                                  <i class="icon icon--next-red-size16"></i>
                                </button>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="planData.next.isUpgrade">
                            <!-- abnormal case -->
                          </template>
                          <template v-else>
                            <ui-button :primary="true" :size="'large'" @click="isShowCancelSubscription = true">
                              {{ $t('common.cancelSubscription') }}
                            </ui-button>
                          </template>
                        </template>
                        <template v-else>
                          <p class="label">{{ planData.next.planName }}{{ $t('common.wireTransaction') }}</p>
                          <p class="value">
                            {{ $t('userInfo.managePlan.default.subscribe.value.nextPlanStartDate', {
                              nextStartDate: getLocaleDateStr(planData.next.startDate)
                            }) }}
                          </p>
                        </template>
                      </template>
                      <template v-else>
                        <ui-button :primary="true" @click="onWithdrawPlanCancellation(false)">
                          {{ $t('common.withdrawPlanCancellation') }}
                        </ui-button>
                      </template>
                    </template>
                    <template v-else>
                      <div>abnormal case</div>
                      <div>{{ planData }}</div>
                    </template>
                  </div>
                </div>
              </div>
            </content-box>
            <content-box class="content__monthly-pv" :width="'35%'" :height="'240px'">
              <p class="content__title">{{ $t('common.monthlyPv') }}</p>
              <div class="content">
                <div class="battery--wrap">
                  <battery-indicator isLargeSize/>
                  <span class="value__pv">
                <template v-if="planData.hasPlan">{{ pvPercentage }}%</template>
                <template v-else>- %</template>
              </span>
                </div>
                <p class="remain-pv">
                  <template v-if="planData.hasPlan">
                    <strong>{{ userData.remainPv | thousand }} PV</strong>/ {{ userData.pvLimit | thousand }} PV
                  </template>
                  <template v-else>
                    <strong>- PV</strong>/ - PV
                  </template>
                </p>
                <div class="plan-period">
                  <p v-if="planData.monthlyStartDate && planData.monthlyEndDate">
                    <time datetime="">{{ planData.monthlyStartDate | dateFormatTimezone(userData.timezoneName) }}</time> ~
                    <time datetime="">{{ planData.monthlyEndDate | dateFormatTimezone(userData.timezoneName) }}</time>
                  </p>
                  <div v-else class="plan-period">-</div>
                </div>
              </div>
            </content-box>
          </div>

          <div class="content__middle">
            <remain-pv-chart
              :startDate="planData.startDate" />
          </div>
          <back-to-top refName="scrollContent"/>
        </div>
      </template>
      <dimmed v-if="dialogData">
        <plan-status-dialog
          :dialogData="dialogData"
          @onConfirm="onPlanStatusDialogConfirm"/>
      </dimmed>
      <dimmed v-if="useDimmed && !isCardRegistering">
        <plan-subscription
          v-if="isShowPlanSubscription"
          :planData="planData"
          :userData="userData"
          @onPlanNumberChange="onPlanNumberChange"
          @closeLayer="isShowPlanSubscription = false" />
        <change-plan
          v-if="!isCardRegistering && newPlanData"
          v-show="!downgradeMore"
          :userData="userData"
          :planData="planData"
          :newPlanData="newPlanData"
          :downgradeMore.sync="downgradeMore"
          @onConfirm="onPlanChangeConfirm"
          @closeLayer="newPlanData = null"/>
        <cancel-subscription
          v-if="isShowCancelSubscription"
          :planData="planData"
          @onCloseLayer="isShowCancelSubscription = false"
          @onConfirm="onCancelSubscription"/>
        <confirm-my-page
          v-if="downgradeMore"
          :planData="planData"
          :downgradeMore.sync="downgradeMore"/>
        <confirm-coupon-user
          v-if="isShowConfirmCouponUser"
          @onConfirm="isShowPlanSubscription = true"
          @closeLayer="isShowConfirmCouponUser = false"/>
      </dimmed>
      <register-card v-if="registerData"
        :userData="userData"
        :registerData="registerData"
        @onRegisterSuccess="onRegisterSuccess"
        @onRegisterCanceled="onRegisterCanceled"
        @onRegisterFailed="onRegisterFailed"/>
    </div>
  </section>
</template>

<script>
import AppDialog from '@/components/ui/AppDialog'
import Dimmed from '@/components/ui/Dimmed'
import ContentBox from '@/components/ui/ContentBox'
import RemainPvChart from '@/components/user-info/manage-plan/RemainPvChart'
import PlanSubscription from '@/components/user-info/manage-plan/PlanSubscription'
import ChangePlan from '@/components/user-info/manage-plan/ChangePlan'
import ConfirmMyPage from '@/components/user-info/manage-plan/ConfirmMyPage'
import CancelSubscription from '@/components/user-info/manage-plan/CancelSubscription'
import PlanStatusDialog from '@/components/user-info/manage-plan/PlanStatusDialog'
import ConfirmCouponUser from '@/components/user-info/manage-plan/ConfirmCouponUser'
import BackToTop from '@/components/ui/BackToTop'
import UiButton from '@/components/ui/UiButton'
import BatteryIndicator from '@/components/header/BatteryIndicator'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import RegisterCard from '@/components/user-info/manage-plan/RegisterCard'
import { openPricing, getLocaleDateStr, tzOffsetDate } from '@/libs/utils'
import { PLAN_NUMBER, getNormalPlanData } from '@/libs/plan-helper'
import { create } from 'vue-modal-dialogs'
import { format } from 'date-fns'
import { mapState, mapGetters, mapActions } from 'vuex'
import { getInfo as getCardInfo } from '@/api/card'
import { createPlan, updatePlan, cancelChange } from '@/api/userPlan'
import browser from '@/libs/browser'

const openDialog = create(AppDialog)

export default {
  components: {
    Dimmed,
    ContentBox,
    BackToTop,
    UiButton,
    BatteryIndicator,
    RemainPvChart,
    PlanSubscription,
    ChangePlan,
    ConfirmMyPage,
    UiLoadingCircle,
    RegisterCard,
    CancelSubscription,
    PlanStatusDialog,
    ConfirmCouponUser
  },
  data () {
    return {
      isLoading: true,
      isShowPlanSubscription: false,
      isShowChangePlan: false,
      isShowCancelSubscription: false,
      isShowConfirmCouponUser: false,
      downgradeMore: null,
      newPlanData: null,
      confirmContentType: null,
      registerData: null,
      dialogData: null,
      pvHistory: null,
      isCardRegistering: false,
      browser: browser
    }
  },
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showStickyData'
    ]),
    ...mapGetters([
      'creditData'
    ]),
    computedPlanEndDate () {
      return tzOffsetDate(this.planData.endDate, this.userData.timezone)
    },
    pvPercentage () {
      return this.creditData.percentage
    },
    useDimmed () {
      return this.isShowPlanSubscription || this.newPlanData ||
        this.isShowCancelSubscription || this.isShowConfirmCouponUser
    }
  },
  methods: {
    ...mapActions([
      'storeUserData',
      'storePlanData'
    ]),
    setPlanInfo () {
      this.isLoading = true
      return this.storePlanData().then(data => {
        return this.storeUserData()
      }).then(() => {
        this.isLoading = false
      }).catch(error => {
        console.error(error)
        this.isLoading = false
      })
    },
    onChangePlan () {
      if (this.planData.isWireTransferPlan) {
        return
      }

      if (this.planData.useCoupon) {
        this.isShowConfirmCouponUser = true
      } else {
        this.isShowPlanSubscription = true
      }
    },
    onViewMorePlans () {
      openPricing()
    },
    onCancelSubscription (reason) {
      // todo: i18n test
      updatePlan(PLAN_NUMBER.terminated, reason).then(data => {
        if (data.planUpdateError || !data.planUpdated) {
          openDialog({
            dialogType: 'plan.cancelSubscriptionFailed'
          })
          return
        }
        const changeDate = format(this.planData.endDate, 'YYYY-MM-DD')
        let status
        let info

        if (this.planData.isUnpaid) {
          status = this.$t('dialog.plan.canceled.unpaid.status')
          info = [this.$t('dialog.plan.canceled.unpaid.info')]
        } else {
          status = this.$t('dialog.plan.canceled.subscription.status')
          info = [
            this.$t('dialog.plan.canceled.subscription.info1', { changeDate }),
            this.$t('dialog.plan.canceled.subscription.info2')
          ]
        }
        this.dialogData = {
          type: 'cancel',
          title: this.$t('dialog.plan.canceled.title'),
          status: status,
          highlight: true,
          info: info
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onWithdrawPlanCancellation (isDowngrade) {
      // todo: i18n test
      cancelChange().then(data => {
        this.dialogData = {
          type: 'cancel',
          title: this.$t('dialog.plan.canceled.title')
        }

        if (isDowngrade) {
          this.dialogData.status = this.$t('dialog.plan.canceled.change.downgrade.status')
          this.dialogData.info = [this.$t('dialog.plan.canceled.change.downgrade.info')]
        } else {
          this.dialogData.status = this.$t('dialog.plan.canceled.change.default.status')
          this.dialogData.highlight = true
        }
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onRegisterSuccess (result) {
      this.registerData = null
      this.isCardRegistering = false
    },
    onRegisterCanceled () {
      this.registerData = null
      this.isCardRegistering = false
      this.newPlanData = null
    },
    onRegisterFailed (result) {
      this.registerData = null
      this.isCardRegistering = false
      this.newPlanData = null

      openDialog({
        dialogType: 'plan.registerCardFailed',
        ok: 'Confirm'
      })
    },
    onPlanNumberChange ({ paymentType, planNumber }) {
      this.newPlanData = getNormalPlanData(planNumber)
      this.isCardRegistering = true
      getCardInfo().then(data => {
        if (!data || !data.iamportCustomerUid) {
          this.registerData = {
            customerUid: null
          }
        } else {
          this.isCardRegistering = false
        }
        this.isShowPlanSubscription = false
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
        this.isShowPlanSubscription = false
      })
    },
    onPlanChangeConfirm (payload) {
      const newPlanNumber = payload.newPlanNumber
      const isDowngrade = payload.isDowngrade

      this.newPlanData = null

      if (this.planData.canChange) {
        this.onUpdatePlan(newPlanNumber, isDowngrade)
      } else {
        this.onCreatePlan(newPlanNumber)
      }
    },
    onCreatePlan (newPlanNumber) {
      createPlan(newPlanNumber).then(data => {
        openDialog({
          dialogType: 'plan.completed',
          ok: this.$t('common.confirm')
        }).then(() => {
          this.setPlanInfo()
        })
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'plan.registerCardFailed'
          })
        }
      })
    },
    onUpdatePlan (newPlanNumber, isDowngrade) {
      updatePlan(newPlanNumber).then(data => {
        if (data.planUpdateError || !data.planUpdated) {
          openDialog({
            dialogType: 'plan.updateFailed'
          })
          return
        }

        const dialogType = isDowngrade ? 'plan.applicationCompleted' : 'plan.completed'
        openDialog({
          dialogType,
          ok: this.$t('common.confirm')
        }).then(() => {
          this.setPlanInfo()
        })
      }).catch(err => {
        if (!err.isHandled) {
          openDialog({
            dialogType: 'common.error'
          })
        }
      })
    },
    onPlanStatusDialogConfirm (type) {
      let reload = false

      switch (type) {
        case 'cancel':
          reload = true
          break
      }

      if (reload) {
        this.setPlanInfo()
      }
      this.dialogData = null
    },
    handlePlanAction (action) {
      if (this.planData.isWireTransferPlan) {
        return
      }

      switch (action) {
        case 'cancelPlanChange':
          this.onWithdrawPlanCancellation(true)
          break
        case 'withdrawPlanCancellation':
          this.onWithdrawPlanCancellation(false)
          break
        case 'cancelPlan':
          this.isShowCancelSubscription = true
          break
        case 'createPlan':
        case 'changePlan':
          this.onChangePlan()
          break
      }
    }
  },
  created () {
    this.PLAN_NUMBER = PLAN_NUMBER
    this.getLocaleDateStr = getLocaleDateStr
    this.setPlanInfo().then(() => {
      const action = this.$route.params.action

      if (action) {
        this.handlePlanAction(action)
      }
    })
  },
  beforeRouteUpdate (to, from, next) {
    const action = to.params.action

    if (action) {
      this.handlePlanAction(action)
    }
    next()
  }
}
</script>

<style lang="scss" scoped="scoped">
  .box-layout {
    position: relative;
    float: left;
    width: calc(100% - 211px);
    margin-top: 33px;
    .manage-plan__content {
      .content__header {
        @include flexXbetween;
        align-items: center;
        margin-left: 30px;
        margin-right: 30px;
        padding-bottom: 16px;

        h2 {
          font-size: 26px;
          font-weight: bold;
          color: #444444;
          padding-left: 10px;
        }

        .button--wrap {
          height: 38px;

          .btn__change {
            margin-right: 5px;
          }
        }
      }
      .loading.circle {
        padding-top: 70vh;
      }
      .content__body {
        height: calc(100vh - 136px);
        padding: 1px 30px 0;
        overflow-y: auto;

        .content--wrap {
          padding: 25px;
          box-sizing: border-box;

          .content__title {
            font-size: 15px;
            font-weight: bold;
            color: #2f2f2f;
            display: inline-block;
            line-height: 21px;
            position: relative;
            vertical-align: top;
            top: -2px;

            .coupon-text {
              margin-left: 9px;
              display: inline-block;
              vertical-align: top;
              text-align: center;
              padding: 0 4px;
              height: 21px;
              box-sizing: border-box;
              line-height: 21px;
              font-size: 12px;
              font-weight: bold;
              color: $brandColor;
              border: solid 1px #ec0047;
              border-radius: 5px;
              position: relative;
              top: -1px;
            }
          }
        }

        .content__top {
          @include flexXbetween;

          .content__plan-in-use {
            margin-right: 15px;
            box-sizing: border-box;

            .content_outer {
              display: flex;
              height: 76px;
              padding: 0 25px;
              justify-content: left;
              align-items: center;
            }

            .content {
              @include flexXcenter;
              align-items: center;

              .label {
                font-size: 14px;
                font-weight: bold;
                line-height: 1;
                color: #767676;
              }
              .value {
                font-size: 14px;
                line-height: 1;
                color: #444;
              }
            }
            .content__plan-name {
              padding: 20px 25px 0 25px;
            }

            .plan-name {
              display: block;
              width: 100%;
              height: 58px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              font-weight: bold;
              line-height: 58px;
              font-size: 30px;
              color: #767676;
              box-sizing: border-box;

              &.using {
                font-size: 40px;
                color: $brandColor;
              }
            }
            .plan-period {
              position: relative;
              .value {
                margin-top: 10px;
                white-space: nowrap;
              }
            }
            .subscribe--wrap {
              position: relative;
              padding-left: 25px;
              margin-left: 25px;
              &:before {
                display: inline-block;
                content: '';
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                width: 1px;
                height: 24px;
                border-left: 1px solid #d7d7d7;
              }
              .value {
                margin-top: 10px;
              }
              .start-subscribe {
                button {
                  margin-top: 10px;
                  font-size: 14px;
                  color: #ec0047;
                  .icon {
                    vertical-align: middle;
                  }
                }
              }
            }
          }
          .content__monthly-pv {
            margin-left: 15px;
            box-sizing: border-box;

            .content {
              text-align: center;
              .battery--wrap {
                @include flexYcenter;
                justify-content: center;
                margin-top: 25px;

                /deep/ .battery_wrap_menu {
                  .battery {
                    &:hover:after {
                      display: none;
                    }
                  }
                  .battery-filling {
                    display: inline-block;
                    position: absolute;
                    top: 22px;
                    left: 9px;
                    height: 16px;
                  }
                  .icon--battery {
                    width: 60px;
                    height: 60px;
                    background-size: contain;
                  }
                }

                .value__pv {
                  font-size: 20px;
                  font-weight: bold;
                  color: #666666;
                  margin-left: 10px;
                }
              }
              .remain-pv {
                margin-top: 10px;
                font-size: 18px;
                color: #767676;
                strong {
                  font-weight: bold;
                  color: $brandColor;
                }
              }
              .plan-period {
                margin-top: 10px;
                font-size: 14px;
                line-height: 1.36;
                color: #444444;
              }
            }
          }
        }
      }
    }
  }
</style>
